<template>
  <section class="section">
    <div class="container is-fluid">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <h2 class="has-text-left is-size-3">{{user.first_name}}, welcome to your Canvas</h2>
          </div>
        </div>

        <div class="level-right board-buttons">
          <div class="level-item">
            <button
              @click="showCanvasModal = true"
              class="button has-text-white new-board-button is-size-5"
            >
              <span style="margin-right:10px;" class="icon is-medium">
                <plus-icon size="1.5x" class></plus-icon>
              </span> New Canvas
            </button>
          </div>
        </div>
      </div>

      <div class="margin-top columns">
        <div class="column has-text-left is-2">
          <ul class="is-size-5">
            <li
              @click="currentCategory = 'all'"
              class="clickable board-category"
              :class="{'active':currentCategory == 'all'}"
            >All ({{boards.length}})</li>
            <li
              @click="currentCategory = 'own'"
              class="clickable board-category"
              :class="{'active':currentCategory == 'own'}"
            >My Canvases ({{ownBoards.length}})</li>
            <li
              @click="currentCategory = 'shared'"
              class="clickable board-category"
              :class="{'active':currentCategory == 'shared'}"
            >Shared with me ({{sharedBoards.length}})</li>
          </ul>
        </div>
        <div class="column is-10">
          <div class="columns is-multiline">
            <div
              v-for="board in displayedBoards"
              :key="board.id"
              class="column is-6-tablet is-4-desktop is-3-widescreen"
            >
              <div
                :style="{backgroundImage: `url(https://generation.ams3.cdn.digitaloceanspaces.com/web-assets/background${(board.id % 4)+1}.jpg)`}"
                class="box board-box"
              >
                <div class="level">
                  <div class="shorten-container level-left">
                    <div class="level-item fullwidth">
                      <h2
                        class="clickable board-title has-text-left is-size-4"
                        @click="goToBoard(board.id)"
                      >{{board.name}}</h2>
                    </div>
                  </div>
                  <div class="level-right">
                    <div class="level-item">
                      <div
                        class="dropdown is-up is-right"
                        :class="{'is-active':activeBoardDropUp == board.id}"
                      >
                        <div class="dropdown-trigger">
                          <a @click="toggleActiveBoardDropUp(board.id,board.owner_id)">
                            <span class="icon is-medium">
                              <more-vertical-icon size="1.5x" class="custom-class"></more-vertical-icon>
                            </span>
                          </a>
                        </div>
                        <div
                          v-if="activeBoardDropUp == board.id"
                          class="dropdown-menu"
                          id="dropdown-menu7"
                          role="menu"
                        >
                          <div v-on-clickaway="closeExpand" class="dropdown-content">
                            <div class="dropdown-item">
                              <div @click="startDeleteItem(board)" class="level clickable">
                                <div class="level-left">
                                  <div class="level-item">
                                    <span class="icon is-medium">
                                      <trash-icon size="2x" class></trash-icon>
                                    </span>
                                  </div>
                                  <div class="level-item">
                                    <p>Delete</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="level">
                  <div class="level-left">
                    <div class="level-item">
                      <span
                        :style="{backgroundImage: `url(${board.owner.profile_url})`}"
                        class="rounded icon is-large"
                      ></span>
                    </div>
                    <div class="level-item">
                      <p>{{board.owner.first_name}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal" :class="{'is-active':showCanvasModal}">
      <div class="modal-background" @click.prevent="cancelCreateCanvas()"></div>
      <div class="modal-content section box">
        <div class="columns is-centered">
          <div class="column is-6">
            <h2>Create a Board</h2>
            <form
              class="has-text-left create-form"
              :class="{'is-loading':creatingBoard}"
              @submit.prevent="createBoard()"
            >
              <div class="field">
                <label class="label">Name</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    v-model="newBoard.name"
                    required
                    placeholder="Name"
                  />
                </div>
              </div>
              <div class="field">
                <label class="label">Description</label>
                <div class="control">
                  <textarea
                    class="textarea"
                    required
                    v-model="newBoard.description"
                    placeholder="Textarea"
                  ></textarea>
                </div>
              </div>
              <div v-if="user.groups.length>1" class="field">
                <label class="label">Class</label>
                <div class="control">
                  <div class="select">
                    <select v-model="newBoard.group_id" required>
                      <option
                        :value="group.id"
                        v-for="(group) in user.groups"
                        :key="group.id"
                      >{{group.name}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="has-text-centered columns is-centered is-mobile field">
                <div class="column">
                  <input type="submit" class="button is-link" />
                </div>
                <div class="column">
                  <button @click.prevent="cancelCreateCanvas()" class="button is-link">Cancel</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <button @click.prevent="cancelCreateCanvas()" class="modal-close is-large" aria-label="close"></button>
    </div>
    <div class="modal" :class="{'is-active':boardBeingDeleted}">
      <div class="modal-background" @click.prevent="boardBeingDeleted = null"></div>
      <div class="modal-content note-modal section box">
        <div class="columns is-centered">
          <div class="column is-6">
            <h2>Deleting Board</h2>
            <p>Are you sure you would like to delete this item? This action cannot be undone.</p>
            <button @click.prevent="boardBeingDeleted = null" class="button is-link">Cancel</button>
            <button
              :class="{'is-loading':deletingBoard}"
              @click.prevent="deleteBoard()"
              class="button is-danger"
            >Confirm</button>
          </div>
        </div>
      </div>
      <button
        @click.prevent="boardBeingDeleted = null"
        class="modal-close is-large"
        aria-label="close"
      ></button>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import Board from "@/models/Board";
import User from "@/models/User";
import { mixin as clickaway } from "vue-clickaway";
import { MoreVerticalIcon, TrashIcon, PlusIcon } from "vue-feather-icons";

export default {
  name: "Canvas",
  mixins: [clickaway],
  components: { MoreVerticalIcon, TrashIcon, PlusIcon },
  data: function() {
    return {
      boardBeingDeleted: null,
      deletingBoard: false,
      showCanvasModal: false,
      currentCategory: "all",
      creatingBoard: false,
      activeBoardDropUp: null,
      newBoard: {
        name: "",
        description: "",
        owner_id: null,
        group_id: null
      }
    };
  },
  computed: {
    ...mapState({
      user(state) {
        return state.auth.user;
      }
    }),
    displayedBoards() {
      let store = Object;
      if (this.currentCategory == "all") {
        store = this.boards;
      } else if (this.currentCategory == "own") {
        store = this.ownBoards;
      } else if (this.currentCategory == "shared") {
        store = this.sharedBoards;
      }
      return store;
    },
    users() {
      return User.all();
    },
    boards() {
      return Board.query()
        .with("owner")
        .get();
    },
    sharedBoards() {
      return Board.query()
        .with("owner")
        .where("owner_id", value => value != this.user.id)
        .get();
    },
    ownBoards() {
      return Board.query()
        .with("owner")
        .where("owner_id", value => value == this.user.id)
        .get();
    }
  },
  methods: {
    closeExpand() {
      this.activeBoardDropUp = null;
    },
    deleteBoard() {
      this.deletingBoard = true;
      Board.deleteBoard(this.boardBeingDeleted.id).then(() => {
        Board.listBoards(["owner"]).then(() => {
          this.deletingBoard = false;
          Board.delete(this.boardBeingDeleted.id);
          this.boardBeingDeleted = null;
        });
      });
    },
    clearActiveBoard() {
      this.activeBoardDropUp = null;
    },
    startDeleteItem(board) {
      this.boardBeingDeleted = board;
      this.clearActiveBoard();
    },
    toggleActiveBoardDropUp(board_id, board_owner_id) {
      if (this.user.id == board_owner_id) {
        if (this.activeBoardDropUp == board_id) {
          this.activeBoardDropUp = null;
        } else {
          this.activeBoardDropUp = board_id;
        }
      }
    },
    goToBoard(id) {
      this.$router.push(`canvas/${id}`);
    },
    cancelCreateCanvas() {
      this.clearForm();
      this.showCanvasModal = false;
    },
    clearForm() {
      Object.keys(this.newBoard).forEach(key => {
        this.newBoard[key] = "";
      });
    },
    createBoard() {
      if (this.user.groups.length == 1) {
        this.newBoard.group_id = this.user.groups[0].id;
      }
      this.creatingBoard = true;
      this.newBoard.owner_id = this.user.id;
      Board.createBoard(this.newBoard)
        .then(result => {
          Board.listBoards(["owner"])
            .then(() => {
              this.creatingBoard = false;
              this.showCanvasModal = false;
            })
            .catch(err => {});
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    this.$store.dispatch("loader/show", "Loading Canvas");

    Board.listBoards(["owner"]).then(() => {
      this.$store.dispatch("loader/hide");
    });
  }
};
</script>

